export default 
[
	{
		name : "assets3D", // Unique Name for each Asset
		type : "gltfModel", // To know which loader to use
		path :
        [
        	// Create a URL which points to the asset we wish to load in the project file structure
        	new URL( "../../../assets/Models/GameAssets.glb", import.meta.url ).href
        ]
	},
	{
		name : "TapToPlace_sound",
		type : "audio",
		path :
        [
        	new URL( "../../../assets/Audio/TapToPlace_v2.mp3", import.meta.url ).href
        ]
	},
	{
		name : "Watering_sound",
		type : "audio",
		path :
        [
        	new URL( "../../../assets/Audio/Watering.mp3", import.meta.url ).href
        ]
	},
	{
		name : "Dirt_sound",
		type : "audio",
		path :
        [
        	new URL( "../../../assets/Audio/Dirt.mp3", import.meta.url ).href
        ]
	},
	{
		name : "Dig_sound",
		type : "audio",
		path :
        [
        	new URL( "../../../assets/Audio/Dig.mp3", import.meta.url ).href
        ]
	},
	{
		name : "Sploosh_sound",
		type : "audio",
		path :
        [
        	new URL( "../../../assets/Audio/Sploosh.mp3", import.meta.url ).href
        ]
	},
];